var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getSource } from "@castiron/domain";
import { SESSION_ATTRIBUTION_KEY } from "./index";
import axios from "axios";
import { removeEmpty } from "../removeEmpty";
const getSessionService = () => __awaiter(void 0, void 0, void 0, function* () {
    const resp = yield axios.get('/session/get', {
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });
    return resp.data;
});
export const propagateAttribution = () => __awaiter(void 0, void 0, void 0, function* () {
    // @ts-ignore
    if (!process.browser)
        return;
    let attribution;
    try {
        const attributionJson = sessionStorage.getItem(SESSION_ATTRIBUTION_KEY);
        if (attributionJson) {
            attribution = JSON.parse(attributionJson);
        }
        else {
            const session = yield getSessionService();
            if (session.attribution) {
                attribution = session.attribution;
                sessionStorage.setItem(SESSION_ATTRIBUTION_KEY, JSON.stringify(attribution));
            }
            else {
                const referrer = window.document.referrer;
                const params = new URLSearchParams(window.location.search);
                attribution = removeEmpty({
                    referringSourceUrl: referrer,
                    source: getSource((referrer)),
                    utmParams: {
                        campaign: params.get('utm_campaign'),
                        source: params.get('utm_source'),
                        term: params.get('utm_term'),
                        medium: params.get('utm_medium'),
                        content: params.get('utm_content')
                    }
                });
                sessionStorage.setItem(SESSION_ATTRIBUTION_KEY, JSON.stringify(attribution));
            }
        }
        return attribution;
    }
    catch (err) {
        console.error('Error getting propagated attribution', err);
        return undefined;
    }
});
//# sourceMappingURL=propagateAttribution.js.map